import { FrustratedPenguinAndErrorDocument } from "raya-lucaria/illustrations";

import { ErrorDisplay } from "./error-display";

interface NotFoundErrorPropType {
  message?: string;
}

export default function GenericError({ message }: NotFoundErrorPropType) {
  return (
    <ErrorDisplay
      message={message}
      defaultTranslationKey="genericErrorMessage"
      Illustration={<FrustratedPenguinAndErrorDocument />}
    />
  );
}
